<template>
  <div class="g-group">
    <input type="checkbox" :ref="group + '-' + keyi" :id="group + '-' + keyi" @change="onChange($event)" />
    <label :for="group + '-' + keyi">{{ value }}</label>
  </div>
</template>

<script>
export default {
  props: {
    keyi: Number,
    value: String,
    group: String,
  },
  data() {
    return {
      isPrevented: false
    }
  },
  methods: {
    onChange(e) {
      this.$emit("onChecked", {
        [this.group]: {
          key: this.value,
          checked: e.target.checked,
          id: this.keyi
        },
      });
    },
    unCheck() {
      this.$refs[this.group + '-' + this.keyi].checked = false
    }
  },
};
</script>

<style scoped>
.g-group {
  display: block;
  margin-bottom: 15px;
}
.g-group input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}
.g-group label {
  position: relative;
  cursor: pointer;
}
.g-group label:before {
  content: "";
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #000;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 5px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
  transform: translateY(-2px);
}

.g-group input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #3b664a;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
